import React, { Component } from 'react'
import styled from 'styled-components'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { media } from '../theme'
import { setSelectedRoom } from '../modules/gameProgress'
import { setStartButtonUrl } from '../modules/gameProgress'
import CheckedSVG from '../assets/images/checked.png'
import TileOverlay from '../assets/images/tile--overlay.png'

const RoomImageContainer = styled.div`
  cursor: pointer;
  position: relative;
  margin: 0 3px;
  width: max(103px, min(12vw, 120px));

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }

  ${media.greaterThan('medium')`
    height: 100%;
  `};
`

const MobileRoomSelectContainer = styled.div`
  width: 230px;
  cursor: pointer;
  position: relative;
  margin: 0 2px;
  overflow: hidden;

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }

  ${media.greaterThan('medium')`
    width: 195px;
  `}
`
const StyledImage = styled.img`
  position: relative;
  height: ${(p) => (p.viewport === 'desktop' ? '100%' : 'auto')};
  max-width: 100%;
`

const Checked = styled.img`
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 50%;
  z-index: 2;
`

const OverlayImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  opacity: ${(p) => (p.selected ? '0' : '0.4')};
  transition: opacity 250ms ease-in-out;
  z-index: 5;

  &:hover {
    opacity: 0;
  }

  ${media.greaterThan('medium')`
    height: 100%;
  `};
`
class RoomOptionTile extends Component {
  constructor(props) {
    super(props)
    this.handleClick = this.handleClick.bind(this)
  }

  alreadyCleared() {
    const { roomsCleared, roomId, gameFinished } = this.props

    if (roomsCleared.includes(roomId) && !gameFinished) {
      return true
    } else {
      return false
    }
  }

  handleClick() {
    const { roomId, url } = this.props
    const { setSelectedRoom, setStartButtonUrl } = this.props
    setSelectedRoom(roomId)
    setStartButtonUrl(url)
  }

  render() {
    if (this.props.viewport === 'desktop') {
      return (
        <RoomImageContainer onClick={this.handleClick}>
          <StyledImage
            selected={this.props.selectedRoom === this.props.roomId}
            src={this.props.img}
            viewport={this.props.viewport}
          />
          <OverlayImage
            selected={this.props.selectedRoom === this.props.roomId}
            src={TileOverlay}
            viewport={this.props.viewport}
          />
          {this.alreadyCleared() && <Checked src={CheckedSVG} />}
        </RoomImageContainer>
      )
    } else {
      return (
        <MobileRoomSelectContainer onClick={this.handleClick}>
          <StyledImage
            selected={this.props.selectedRoom === this.props.roomId}
            src={this.props.img}
            viewport={this.props.viewport}
          />
          <OverlayImage
            selected={this.props.selectedRoom === this.props.roomId}
            src={TileOverlay}
            viewport={this.props.viewport}
          />
          {this.alreadyCleared() && <Checked src={CheckedSVG} />}
        </MobileRoomSelectContainer>
      )
    }
  }
}

const mapStateToProps = (state) => {
  return {
    selectedRoom: state.gameProgress.selectedRoom,
    roomsCleared: state.gameProgress.roomsCleared,
    gameFinished: state.gameProgress.gameFinished,
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ setSelectedRoom, setStartButtonUrl }, dispatch)

const RoomOptionTileConnected = connect(
  mapStateToProps,
  mapDispatchToProps,
)(RoomOptionTile)
export default RoomOptionTileConnected



// WEBPACK FOOTER //
// ./src/components/RoomOptionTile.js